export const setContractPlan = 'setContractPlan'



// WEBPACK FOOTER //
// ./src/app/pages/contract_plans/vuex/mutations-types.js